<template>
  <div class="edit-form">
    <el-form :model="dataForm" ref="dataForm" v-loading="formLoading"
             label-width="120px">
      <el-form-item label="表结构信息:" prop="desc">
        <textarea ref="tabEditor" class="codesql" rows="20" v-model="dataForm.desc"></textarea>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import 'codemirror/theme/ambiance.css'
import 'codemirror/lib/codemirror.css'
import 'codemirror/addon/hint/show-hint.css'
import 'codemirror/addon/edit/matchbrackets'
import 'codemirror/addon/selection/active-line'
import 'codemirror/mode/sql/sql'
import 'codemirror/addon/hint/sql-hint'
import 'codemirror/addon/hint/show-hint'
import CodeMirror from 'codemirror/lib/codemirror'
import {aesEncrypt, aesDecrypt} from '@/utils'
export default {
  props: {
    dataSetId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      formLoading: false,
      dataForm: {
        id: '',
        desc: ''
      },
      tabEditor: null,
    }
  },
  mounted() {
    this.dataForm.id = this.dataSetId
    this.loadData();
    // this.initEditor();
  },
  methods: {
    loadData() {
      this.formLoading = true
      this.$http({
        url: this.$http.adornUrl('/customform/tablemeta/scripts?tableId=' + this.dataForm.id),
        method: 'get',
        baseURL: '',
      }).then(({data}) => {
        if (data && data.data && data.code === '1') {
          const temp = aesDecrypt(data.data);
          this.dataForm.desc = temp;
          this.$nextTick(() => {
            this.tabEditor.setValue(temp);
          })

        } else {
          this.dataForm.desc = ''
        }
        this.formLoading = false
      })
    },
    initEditor() {
      console.log("initEditor")
      const mime = "text/x-mysql";
      this.tabEditor = CodeMirror.fromTextArea(this.$refs.tabEditor, {
        mode: mime,
        theme: "ambiance",
        indentWithTabs: true,
        smartIndent: true,
        lineNumbers: true,
        matchBrackets: true,
        lineWrapping: true,
        line: true,
        spellcheck: true,
        scrollbarStyle: null,
        hintOptions: {
          completeSingle: false
        }
      });

      let _that=this;
      _that.tabEditor.on('inputRead',()=>{
        _that.tabEditor.showHint();
      })
    },
    breakEditor(){
      if (this.tabEditor){
        this.tabEditor.toTextArea();
        this.tabEditor=null;
      }
    }
  }
}
</script>
<style scoped="scoped">

</style>
